/** One line of gratitude for one local calendar day. */
export interface JournalEntry {
    /** Local day key, `YYYY-MM-DD` (see `dayKey`). One entry per day. */
    day: string;
    text: string;
    /** Milliseconds since the epoch when it was last written. */
    at: number;
}

export const JOURNAL_MAX_LENGTH = 200;
export const PROMPT_COUNT = 6;

/** Whole days since the epoch for a day key. Calendar arithmetic in UTC, so time zones and DST never matter. */
const dayNumber = (key: string): number => {
    const [y, m, d] = key.split('-').map(Number);
    return Math.round(Date.UTC(y, m - 1, d) / 86400000);
};

/**
 * Consecutive days with an entry, ending today. A day not yet written does not break the streak:
 * it still counts up to yesterday.
 */
export const journalStreak = (days: string[], today: string): number => {
    const set = new Set(days.map(dayNumber));
    let cursor = dayNumber(today);
    if (!set.has(cursor)) cursor -= 1;
    let streak = 0;
    while (set.has(cursor)) {
        streak += 1;
        cursor -= 1;
    }
    return streak;
};

/** Index of today's prompt: it changes daily and is the same all day. */
export const promptIndex = (today: string): number =>
    ((dayNumber(today) % PROMPT_COUNT) + PROMPT_COUNT) % PROMPT_COUNT;

/** The entries as a downloadable JSON document. */
export const exportJournal = (entries: JournalEntry[]): string =>
    JSON.stringify(
        entries.map(({ day, text }) => ({ day, text })),
        null,
        2
    );
